import getAxiosBasicUrlAndHeader from 'api/helpers/getAxiosBasicUrlAndHeader'
import axios from 'axios'

/**
 * requires user to have group code 6A
 * @param {Array} ids
 * @param {*} userInputForm
 * @param {*} session
 * @returns Promise success or fail message
 */
const alertMuteService = async (ids, userInputForm, session) => {
  const id = ids[0]
  const { notes, durationMins } = userInputForm

  const jsonBody = {
    stationCode: id.stationCode,
    blockIndex: id.blockIndex,
    bessStatusCode: id.bessStatusCode,
    startTimestamp: id.startTimestamp.epochMillis,
    durationMins: durationMins,
    notes: notes,
  }

  const { apiUrl, axiosHeader } = getAxiosBasicUrlAndHeader(session)

  return await axios
    .put(`${apiUrl}alerts/mute`, jsonBody, axiosHeader)
    .then((res) => res.data)
}

export default alertMuteService

export const getMuteDurationDictionary = async (session) => {
  const { apiUrl, axiosHeader } = getAxiosBasicUrlAndHeader(session)
  return await axios
    .get(`${apiUrl}alerts/muteDuration`, axiosHeader)
    .then((res) => res.data)
}
